import { lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'simplebar';
import 'simplebar/dist/simplebar.css';
import Loadable from 'ui-components/SniperLoading/Loadable';
const App = Loadable(lazy(() => import('./App')));
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
